import { TaskSearchSchema } from '@school-manage/schema/search.schema';
import { warnIfOfflineNoCache } from '@school-manage/utils/offline';
import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';

import { TaskError } from './-components/error/TaskError';
import { Task } from './-components/Task';
import { useTask } from './-logic/useTask';
import { TaskContext } from './-logic/useTaskContext';

export const Route = createFileRoute('/_authed/task/')({
  beforeLoad: ({ context: { queryClient }, location, search }) => {
    warnIfOfflineNoCache(location, [
      queryClient.getQueryData(['tasks', search]),
    ]);
  },
  component: TaskPage,
  errorComponent: TaskError,
  validateSearch: zodValidator(TaskSearchSchema),
});

function TaskPage() {
  return (
    <TaskContext.Provider value={useTask()}>
      <Task />
    </TaskContext.Provider>
  );
}
